import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Card, CardBody, Col, Row, Table } from "reactstrap";
import {
  GET_RP_DEMAND_EXIT,
  GET_RP_SUPPLY_DEMAND_ENTRY,
  GET_RP_SUPPLY_DEMAND_EXIT,
  GET_RP_SUPPLY_ENTRY,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import BarChartEntry from "../SectionDemandSupply/BarChartEntry";
import BarChartExit from "../SectionDemandSupply/BarChartExit";
import PropTypes from "prop-types";
import TableSupplyDemand from "./TableSupplyDemand";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import moment from "moment";

function SectionDemandSupply(props) {
  const dispatch = useDispatch();
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [total, setTotal] = useState({});

  const [dataListMerge, setDataListMerge] = useState({
    entryDataList: [],
    exitDataList: [],
    dtEntry: [],
    dtExit: [],
  });
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const getColumnEntry = () => post(GET_RP_SUPPLY_DEMAND_ENTRY, {});
  const getColumnExit = () => post(GET_RP_SUPPLY_DEMAND_EXIT, {});

  const generateRow = () => {
    let entryList = [
      ...dataListMerge.entryDataList.filter(
        row => row.SUPPLYDEMAND_SHOW == true
      ),
    ];
    let exitList = [
      ...dataListMerge.exitDataList.filter(
        row => row.SUPPLYDEMAND_SHOW == true
      ),
    ];
    let rowData = [];
    entryList.map(row => {
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`ENTRY_${key}`] = value;
      }

      let prevData = rowData.find(
        prev => prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME
      );
      if (prevData) {
        rowData = rowData.map(prev => {
          if (prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME) {
            return { ...prev, ...obj };
          }
          return prev;
        });
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME;
        rowData.push(obj);
      }
    });
    exitList.map(row => {
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`EXIT_${key}`] = value;
      }

      let prevData = rowData.find(
        prev => prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME
      );

      if (prevData) {
        rowData = rowData.map(prev => {
          if (prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME) {
            return { ...prev, ...obj };
          }
          return prev;
        });
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME;
        rowData.push(obj);
      }
    });
    rowData = rowData.map((row, index) => ({ ...row, row: index }));

    let tempRowData = addFieldToModelDeviceList(rowData);

    if (tempRowData) setModelDeviceList([...tempRowData]);
  };

  const fetchData = async () => {
    function compare(a, b) {
      if (a.SUPPLYDEMAND_ORDER < b.SUPPLYDEMAND_ORDER) {
        return -1;
      }
      if (a.SUPPLYDEMAND_ORDER > b.SUPPLYDEMAND_ORDER) {
        return 1;
      }
      return 0;
    }

    dispatch(loadingAction.showLoading());
    try {
      let [entry, exit, dtEntry, dtExit] = await Promise.all([
        getColumnEntry(),
        getColumnExit(),
        post(GET_RP_SUPPLY_ENTRY, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
        post(GET_RP_DEMAND_EXIT, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
      ]);

      // console.log(entry);
      // console.log(exit);
      // console.log(dtEntry);
      // console.log(dtEntry);
      setDataListMerge({
        entryDataList: entry.data.rpSupplyDemandEntryList
          .sort(compare)
          .filter(obj => obj.SUPPLYDEMAND_SHOW == true)
          .map((obj, index) => ({
            ...obj,
            ROW: index + 1,
          })),
        exitDataList: exit.data.rpSupplyDemandExitList
          .sort(compare)
          .filter(obj => obj.SUPPLYDEMAND_SHOW == true)
          .map((obj, index) => ({
            ...obj,
            ROW: index + 1,
          })),

        dtEntry: dtEntry.data.rpSupplyEntryList,
        dtExit: dtExit.data.RPDemandExitList,
      });
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid]);

  useEffect(() => {
    if (
      dataListMerge.entryDataList.length > 0 ||
      dataListMerge.exitDataList.length > 0
    ) {
      generateRow();
    }
  }, [dataListMerge]);

  const addFieldToModelDeviceList = rowList => {
    // console.log(dataListMerge.dtEntry)
    let dataModel = {
      PID: "",
      SUPPLYDEMAND_PID: "",
      SUPPLYDEMAND_ORDER: 0,
      SUPPLYDEMAND_NAME: "",
      SUPPLY_PLAN_ENTRY: "",
      SUPPLY_ACTUAL_ENTRY: "",
      SUPPLY_DIFF_ENTRY: "",
      DEMAND_PLAN_EXIT: "",
      DEMAND_ACTUAL_EXIT: "",
      DEMAND_DIFF_EXIT: "",
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let mergeEntryCell = [];
      let mergeExitCell = [];
      let notInList = [];
      dataListMerge.entryDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.entryDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {
            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_DESC == e.SUPPLYDEMAND_DESC &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE
            ) {
              let preventData = mergeEntryCell.find(
                obj => obj.ENTRY_group == index
              );
              notInList.push(e.PID);
              if (preventData) {
                mergeEntryCell = [
                  ...mergeEntryCell.map(prev => {
                    if (prev.ENTRY_group == index) {
                      prev.ENTRY_subPid = [...prev.ENTRY_subPid, e.PID];
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeEntryCell.push({
                  ENTRY_group: index,
                  ENTRY_mainPid: row.PID,
                  ENTRY_subPid: [e.PID],
                });
              }
            }
          });
      });
      // console.log(mergeEntryCell)
      dataListMerge.exitDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.exitDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {
            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE &&
              row.SUPPLYDEMAND_SET1 == e.SUPPLYDEMAND_SET1 &&
              row.SUPPLYDEMAND_OVERHEAD1 == e.SUPPLYDEMAND_OVERHEAD1 &&
              row.SUPPLYDEMAND_DIVISOR1 == e.SUPPLYDEMAND_DIVISOR1 &&
              row.SUPPLYDEMAND_WEIGHT_SET1 == e.SUPPLYDEMAND_WEIGHT_SET1 &&
              row.SUPPLYDEMAND_WEIGHT_DIV1 == e.SUPPLYDEMAND_WEIGHT_DIV1 &&
              row.SUPPLYDEMAND_SET2 == e.SUPPLYDEMAND_SET2 &&
              row.SUPPLYDEMAND_OVERHEAD2 == e.SUPPLYDEMAND_OVERHEAD2 &&
              row.SUPPLYDEMAND_DIVISOR2 == e.SUPPLYDEMAND_DIVISOR2 &&
              row.SUPPLYDEMAND_WEIGHT_SET2 == e.SUPPLYDEMAND_WEIGHT_SET2 &&
              row.SUPPLYDEMAND_WEIGHT_DIV2 == e.SUPPLYDEMAND_WEIGHT_DIV2 &&
              row.SUPPLYDEMAND_SET3 == e.SUPPLYDEMAND_SET3 &&
              row.SUPPLYDEMAND_OVERHEAD3 == e.SUPPLYDEMAND_OVERHEAD3 &&
              row.SUPPLYDEMAND_DIVISOR3 == e.SUPPLYDEMAND_DIVISOR3 &&
              row.SUPPLYDEMAND_WEIGHT_SET3 == e.SUPPLYDEMAND_WEIGHT_SET3 &&
              row.SUPPLYDEMAND_WEIGHT_DIV3 == e.SUPPLYDEMAND_WEIGHT_DIV3
            ) {
              // console.log(2);
              let preventData = mergeExitCell.find(
                obj => obj.EXIT_group == index
              );
              notInList.push(e.PID);
              if (preventData) {
                mergeExitCell = [
                  ...mergeExitCell.map(prev => {
                    if (prev.EXIT_group == index) {
                      prev.EXIT_subPid = [...prev.EXIT_subPid, e.PID];
                      prev.DEMAND_PLAN_EXIT_REDUCE =
                        prev.DEMAND_PLAN_EXIT_REDUCE + e.DEMAND_PLAN_EXIT;
                      prev.DEMAND_ACTUAL_EXIT_REDUCE =
                        prev.DEMAND_ACTUAL_EXIT_REDUCE + e.DEMAND_ACTUAL_EXIT;
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeExitCell.push({
                  EXIT_group: index,
                  EXIT_mainPid: row.PID,
                  EXIT_subPid: [e.PID],
                  DEMAND_PLAN_EXIT_REDUCE: row.DEMAND_PLAN_EXIT,
                  DEMAND_ACTUAL_EXIT_REDUCE: row.DEMAND_ACTUAL_EXIT,
                });
              }
            }
          });
      });
      // console.log(mergeExitCell);
      let modelList = [];

      rowList.map(objRow => {
        // console.log(objRow,dataListMerge.dtEntry)
        let dataEntry = dataListMerge.dtEntry.find(
          row => row.SUPPLYENTRY_PID == objRow.ENTRY_PID
        );
        let dataExit = dataListMerge.dtExit.find(
          row => row.DEMANDEXIT_PID == objRow.EXIT_PID
        );
        // console.log(dataEntry)
        let mergeEntry = mergeEntryCell.find(
          row =>
            objRow.ENTRY_PID == row.ENTRY_mainPid ||
            row.ENTRY_subPid.indexOf(objRow.ENTRY_PID) >= 0
        );
        let mergeExit = mergeExitCell.find(
          row =>
            objRow.EXIT_PID == row.EXIT_mainPid ||
            row.EXIT_subPid.indexOf(objRow.EXIT_PID) >= 0
        );
        // console.log(mergeExit);
        modelList.push({
          ...dataModel,
          ...objRow,
          ...dataEntry,
          ...dataExit,
          ENTRY_groups: mergeEntry ? mergeEntry.ENTRY_group : null,
          ENTRY_rowspan: mergeEntry ? mergeEntry.ENTRY_subPid.length + 1 : null,
          EXIT_groups: mergeExit ? mergeExit.EXIT_group : null,
          EXIT_rowspan: mergeExit ? mergeExit.EXIT_subPid.length + 1 : null,
        });
      });
      // console.log(modelList);
      rowList.map(objRow => ({ ...dataModel, ...objRow }));
      let totalRow = modelList.reduce(function (accumulator, item) {
        accumulator["SUPPLY_PLAN_ENTRY"] =
          (accumulator["SUPPLY_PLAN_ENTRY"] || 0) + item["SUPPLY_PLAN_ENTRY"];
        accumulator["SUPPLY_ACTUAL_ENTRY"] =
          (accumulator["SUPPLY_ACTUAL_ENTRY"] || 0) +
          item["SUPPLY_ACTUAL_ENTRY"];
        accumulator["DEMAND_PLAN_EXIT"] =
          (accumulator["DEMAND_PLAN_EXIT"] || 0) + item["DEMAND_PLAN_EXIT"];
        accumulator["DEMAND_ACTUAL_EXIT"] =
          (accumulator["DEMAND_ACTUAL_EXIT"] || 0) + item["DEMAND_ACTUAL_EXIT"];
        return { ...dataModel, ...accumulator, SUPPLYDEMAND_NAME: "Total" };
      }, {});

      let entryReduce = mergeEntryCell.reduce(
        (total, item) => {
          let temp = dataListMerge.dtEntry.find(
            row => item.ENTRY_subPid.indexOf(row.SUPPLYENTRY_PID) >= 0
          );
          if (temp) {
            total.SUPPLY_PLAN_ENTRY =
              total.SUPPLY_PLAN_ENTRY + temp.SUPPLY_PLAN_ENTRY;
            total.SUPPLY_ACTUAL_ENTRY =
              total.SUPPLY_ACTUAL_ENTRY + temp.SUPPLY_ACTUAL_ENTRY;
          }
          return { ...total };
        },
        { SUPPLY_PLAN_ENTRY: 0, SUPPLY_ACTUAL_ENTRY: 0 }
      );
      let exitReduce = mergeExitCell.reduce(
        (total, item) => {
          let temp = dataListMerge.dtExit.find(
            row => item.EXIT_subPid.indexOf(row.DEMANDEXIT_PID) >= 0
          );
          if (temp) {
            total.DEMAND_PLAN_EXIT =
              total.DEMAND_PLAN_EXIT + temp.DEMAND_PLAN_EXIT;
            total.DEMAND_ACTUAL_EXIT =
              total.DEMAND_ACTUAL_EXIT + temp.DEMAND_ACTUAL_EXIT;
          }
          return { ...total };
        },
        { DEMAND_PLAN_EXIT: 0, DEMAND_ACTUAL_EXIT: 0 }
      );
      totalRow.SUPPLY_PLAN_ENTRY =
        totalRow.SUPPLY_PLAN_ENTRY - entryReduce.SUPPLY_PLAN_ENTRY;

      totalRow.SUPPLY_ACTUAL_ENTRY =
        totalRow.SUPPLY_ACTUAL_ENTRY - entryReduce.SUPPLY_ACTUAL_ENTRY;

      totalRow.DEMAND_PLAN_EXIT =
        totalRow.DEMAND_PLAN_EXIT - exitReduce.DEMAND_PLAN_EXIT;

      totalRow.DEMAND_ACTUAL_EXIT =
        totalRow.DEMAND_ACTUAL_EXIT - exitReduce.DEMAND_ACTUAL_EXIT;

      totalRow.SUPPLY_DIFF_ENTRY = `${totalRow.SUPPLY_PLAN_ENTRY != totalRow.SUPPLY_ACTUAL_ENTRY
        ? totalRow.SUPPLY_PLAN_ENTRY > totalRow.SUPPLY_ACTUAL_ENTRY
          ? "-"
          : "+"
        : ""
        } ${Math.abs(totalRow.SUPPLY_PLAN_ENTRY - totalRow.SUPPLY_ACTUAL_ENTRY)}`;
      totalRow.DEMAND_DIFF_EXIT = `${totalRow.DEMAND_PLAN_EXIT != totalRow.DEMAND_ACTUAL_EXIT
        ? totalRow.DEMAND_PLAN_EXIT > totalRow.DEMAND_ACTUAL_EXIT
          ? "-"
          : "+"
        : ""
        } ${Math.abs(totalRow.DEMAND_PLAN_EXIT - totalRow.DEMAND_ACTUAL_EXIT)}`;
      setTotal(totalRow);

      return [...modelList, totalRow];
    }
  };

  return (
    <Row>

      <Row className="mt-0">
        <Col sm="6">
          <h5
            className="mb-0 sm-0"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            System Entry & Exit Summary
          </h5>
        </Col>
        <Col sm="6">
          <h5
            className="mb-0 sm-0 d-flex align-items-center justify-content-end"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}

          </h5>
        </Col>
      </Row>
      <Row className="mt-2">
        <hr />
      </Row>
      <div className="d-flex dashboard-content-body" >
        <div className="d-flex flex-column" style={{ flex: 1.5 }}>
          <div className="d-flex" style={{ flex: 1, margin: 5, position: "relative" }}>
            {/* <div style={{ flex: 0.2, minWidth: '90px' }} className="mt-0"> */}
            <div style={{ width: '17%' }} className="mt-0">
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#556ee678",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Planed Exit
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>{numberFormat(total.DEMAND_PLAN_EXIT, 0)}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Actual Exit
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>
                      {numberFormat(total.DEMAND_ACTUAL_EXIT, 0)}
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Diff Exit
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>{numberFormat(total.DEMAND_DIFF_EXIT, 0)}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
            {/* <div style={{ flex: 1 }} className="mt-0"> */}
            <div style={{ width: "83%", position: 'relative', height: "90%" }} className="mt-0">
              <BarChartExit modelDeviceList={modelDeviceList} />
            </div>
          </div>
          <div className="d-flex" style={{ flex: 1, margin: 5, position: "relative" }}>
            {/* <div style={{ flex: 0.2, minWidth: '90px' }} className="mt-0"> */}
            <div style={{ width: '17%' }} className="mt-0">
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#2c64b6a8",
                        color: "#FEF8B0",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "1vw",
                      }}
                    >
                      Planed Entry
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1.5vw",
                  }}
                >
                  <tr>
                    <td>
                      {numberFormat(total.SUPPLY_PLAN_ENTRY, 0)}
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#2c64b6a8",
                        color: "#FEF8B0",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Actual Entry
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>
                      {numberFormat(total.SUPPLY_ACTUAL_ENTRY, 0)}
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#2c64b6a8",
                        color: "#FEF8B0",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Diff Entry
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>
                      {numberFormat(total.SUPPLY_DIFF_ENTRY, 0)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            {/* <div style={{ flex: 1 }} className="mt-0"> */}
            <div style={{ width: "83%", position: 'relative', height: "90%" }} className="mt-0">
              <BarChartEntry modelDeviceList={modelDeviceList} />
            </div>
          </div>
        </div>
        <div
          // className="d-flex flex-column"
          style={{ width: "70vh" }} //flex: 1.4,width: "1000px"
        >
          <TableSupplyDemand
            date={props.date}
            summaryReportPid={props.summaryReportPid}
            modelDeviceList={modelDeviceList}
          />
        </div>
      </div>

    </Row>
  );
}

SectionDemandSupply.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};
export default SectionDemandSupply;
